import React, { useEffect } from "react";
import { Col, Row, Alert, Button } from "antd";
import NewsItems from "../components/NewsItems";
import CourseItems from "../components/CourseItems";
import { useQuery, gql } from "@apollo/client";
import useAuth from "../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganisationItemAsync, selectOrganisation } from "../features/organisations/organisationsSlice";
import { getImageURL } from "../util/images";

export default function Home() {
  const { auth } = useAuth();
  const dispatch = useDispatch();
  // const { loading, error, data } = useQuery(HomePage);

  const organisationData = useSelector(selectOrganisation);

  const data = useSelector((state) => state.organisation.content);
  const status = useSelector((state) => state.organisation.status);
  const error = useSelector((state) => state.organisation.error);
  const org = useSelector((state) => state.organisation.organisation);
  const manualApprovalEnabled = org?.attributes?.LMS.enable_manual_approval;
  const isUserConfirmed = manualApprovalEnabled ? auth.getUser().confirmed && auth.getUser().isUserApproved : true;

  const news = useSelector((state) => state.news.news);
  const courses = useSelector((state) => state.courses.courses);

  useEffect(() => {
    if (status === "idle" || (status === "fulfilled" && !data)) {
      dispatch(fetchOrganisationItemAsync());
    }
  }, [auth, data, dispatch, status]);

  if (status === "pending" || !data) return <div className="AlertInfo Loading">Loading...</div>;
  if (error) return <p>Error :(</p>;

  return (
    <div className="Home">
      {data.attributes.showAlert && (
        <Alert type="error" message={data.attributes.alertText} className="AppAlert" banner closable showIcon={false} />
      )}
      <section
        className="Hero"
        style={{
          backgroundImage: `url('${getImageURL(data.attributes.heroImage.data?.attributes.url)}')`,
        }}
      >
        <div className="AppContainer">
          <Row>
            <Col lg={12}></Col>
            <Col lg={12}>
              <h1>{data.attributes.heroTitle}</h1>
              <p className="preserveSpace">{data.attributes.heroDescription}</p>
              {!auth.isLoggedIn() && (
                <Button href="/login" type="primary" size="small" style={{ marginTop: "30px", width: "100px" }}>
                  Login
                </Button>
              )}
            </Col>
          </Row>
        </div>
      </section>

      {auth.isLoggedIn() && (
        <>
          <section>
            {organisationData?.attributes?.LMS?.show_news && isUserConfirmed && (
              <div className="AppContainer">
                {news?.length > 0 && <h2 className="SectionTitle">Latest News</h2>}
                <NewsItems />
              </div>
            )}
          </section>
          <section>
            <div className="AppContainer">
              {courses?.length > 0 && <h2 className="SectionTitle">My Learning</h2>}
              <CourseItems />
            </div>
          </section>
        </>
      )}
    </div>
  );
}
